import NiceModal from '@ebay/nice-modal-react';
import React, { Suspense } from 'react';

import { MODALS } from '@/shared/config/modals';

const RollsHowItWorksModalLazy = React.lazy(() =>
  import('./RollsHowItWorksModal').then((m) => ({ default: m.RollsHowItWorksModal })),
);

NiceModal.register(
  MODALS.ROLLS_HOW_IT_WORKS,
  NiceModal.create(() => (
    <Suspense fallback={null}>
      <RollsHowItWorksModalLazy />
    </Suspense>
  )),
);

const JettonHowItWorksModalLazy = React.lazy(() =>
  import('./JettonHowItWorksModal').then((m) => ({ default: m.JettonHowItWorksModal })),
);

NiceModal.register(
  MODALS.JETTON_HOW_IT_WORKS,
  NiceModal.create(() => (
    <Suspense fallback={null}>
      <JettonHowItWorksModalLazy />
    </Suspense>
  )),
);
